import React from "react";
import Header from "../components/header";
import AdminNewCheckListTable from "../containers/adminNew/adminNewChecklistTable";

export default function AdminNewCheckList() {
  return (
    <>
      <Header>Tech Certify Tractor</Header>
      <AdminNewCheckListTable />
    </>
  );
}
